const getDefaultState = () => {
	return {
		subscription: {},
		partnershipSubscription: {}
	}
}

export default getDefaultState
